/* ------------------------------------ */
// Navbar data section
/* ------------------------------------ */
import logo from '../../assets/image/appCreative/logo.png';
export const navbar = {
  logoImage: logo,
  navMenu: [
    {
      id: 1,
      label: 'Home',
      path: '/#home',
      staticLink: '/',
    },
    {
      id: 2,
      label: 'Why Linok?',
      staticLink: '/why-linok',
      path: '/why-linok',
    },
    {
      id: 3,
      label: 'ROI Calculator',
      staticLink: '/calculator',
      path: '/calculator',
    },
    {
      id: 4,
      label: 'About Us',
      staticLink: '/about-us',
      path: '/about-us',
    },
    // {
    //   id: 5,
    //   label: 'Linok Blog',
    //   staticLink: '/posts',
    //   path: '/posts',
    // },
    {
      id: 6,
      label: 'Contact Us',
      path: '/contact-us',
      staticLink: '/contact-us',
    },
    {
      id: 7,
      label: 'Request a Demo',
      path: '/get-started',
      staticLink: '/get-started',
      isCta: true,
    },
  ],
};

/* ------------------------------------ */
// Key Features data section
/* ------------------------------------ */
import keyFeature1 from '../../assets/image/appCreative/key_feature/plug-play.svg';
import keyFeature2 from '../../assets/image/appCreative/key_feature/vitamin.svg';
import keyFeature3 from '../../assets/image/appCreative/key_feature/big-data.svg';
import keyFeature4 from '../../assets/image/appCreative/key_feature/quality_increase.svg';

export const keyFeatures = {
  title: 'Affordable, Real-Time Detection of Mastitis and Milk Quality Monitoring',
  slogan: '',
  features: [
    {
      id: 1,
      icon: keyFeature1,
      title: 'Plug & Play IoT Sensor',
      description: 'Linok’s Plug & Play IoT Sensor is designed for seamless integration into your dairy operations',
    },
    {
      id: 2,
      icon: keyFeature2,
      title: 'Lowering antibiotic usage dramatically',
      description: 'Reduce antibiotic usage dramatically with Linok’s real-time monitoring, enabling early detection of subclinical conditions and promoting healthier herd management',
    },
    {
      id: 3,
      icon: keyFeature3,
      title: 'Big data insights & economical recommendations per farm',
      description: 'Unlock big data insights and receive tailored economical recommendations for your farm, empowering smarter decisions and maximizing profitability with Linok',
    },
    {
      id: 4,
      icon: keyFeature4,
      title: 'Increasing milk quality and decreasing veterinary expenditure',
      description: 'Increase milk quality while significantly reducing veterinary expenditures with Linok’s precise real-time monitoring and proactive health management',
    },
  ],
};

/* ------------------------------------ */
// Certification (3-A Symbol) data section
/* ------------------------------------ */
// Transparent version derived from the official 3-A SSI JPG (mark + standard
// number 46-04). The original JPGs are kept alongside as backup copies.
import threeASymbol from '../../assets/image/appCreative/3a-symbol-46-04.png';

export const certification = {
  title: 'Certified to 3-A Sanitary Standards',
  slogan:
    'The Linok MIKA-V1 meets the requirements of 3-A Sanitary Standard 46-04.',
  symbol: threeASymbol,
  symbolAlt: '3-A Symbol — Sanitary Standard 46-04',
  verifyLabel: 'Verify authorization',
  verifyUrl:
    'https://my.3-a.org/3-A-Symbol-Certificates/-Search-Database-of-Current-Certificates',
};

/* ------------------------------------ */
// Choose us data section
/* ------------------------------------ */
import chooseThumb from '../../assets/image/appCreative/worldwide2.png';
import iasLogo from '../../assets/image/ias_logo.png';
import thomsonLogo from '../../assets/image/thomson_logo.png';
import wgDairyLogo from '../../assets/image/wg_dairy_supply_logo.png';

export interface Distributer {
  id: number;
  title: string;
  contactName?: string;
  position?: string;
  company?: string;
  address?: string;
  phone?: string;
  cell?: string;
  email?: string;
  website?: string;
  logo?: string;
  status?: boolean;
}

export interface WorldwideData {
  title: string;
  join: string;
  thumb: string;
  distributers: Distributer[];
}

export const Worldwide: WorldwideData = {
  title: 'Linok Partners',
  join: 'Become a Partner',
  thumb: chooseThumb,
  distributers: [
    {
      id: 1,
      title: 'United States',
      contactName: 'Thomson Services',
      logo: thomsonLogo,
      phone: '(254) 445-1818',
      email: 'info@thomsonservices.com',
      website: 'www.thomsonservices.com',
      status: true
    },
    // {
    //   id: 1,
    //   title: 'United-State',
    //   contactName: 'Dwayne R Zimmerman',
    //   position: 'Founder & CTO',
    //   company: 'QuantumTek.AG',
    //   address: '609 State Route 414, Clyde NY 14433',
    //   phone: '(717) 821-0278',
    //   email: 'dwayne@quatumtek.ag',
    //   status: true
    // },
    // {
    //   id: 2,
    //   title: 'Canada',
    //   contactName: 'Calvin Lichty',
    //   phone: '(519) 835-3649',
    //   email: 'carvinty@xplornet.com',
    //   status: true
    // },
    {
      id: 2,
      title: 'United States',
      contactName: 'W.G Dairy Supply',
      logo: wgDairyLogo,
      phone: '(330) 435-6522',
      email: 'sales@wgdairysupply.com',
      website: 'www.wgdairysupply.com',
      status: true
    },
    {
      id: 3,
      title: 'United States',
      contactName: 'IAS',
      logo: iasLogo,
      phone: '(585) 270-0602',
      cell: '(717) 821-0278',
      email: 'dwayne@ias.ag',
      status: true
    }
  ],
};

/* ------------------------------------ */
// Experience data section
/* ------------------------------------ */
import expIcon1 from '../../assets/image/appCreative/experience/1.png';
import expIcon2 from '../../assets/image/appCreative/experience/2.png';

// Client Logo
import geekwire from '../../assets/image/appCreative/client_logo/1.png';
import slack from '../../assets/image/appCreative/client_logo/2.png';
import envato from '../../assets/image/appCreative/client_logo/3.png';
import usaToday from '../../assets/image/appCreative/client_logo/4.png';
import forbes from '../../assets/image/appCreative/client_logo/5.png';
import evernote from '../../assets/image/appCreative/client_logo/6.png';

export const experiences = {
  title: 'Why Linok?',
  subtitle: 'Empowering Dairy Today',
  slogan:
    'At Linok, we harness the power of advanced sensor technology and machine learning to provide real-time data on milk quality, helping dairy farmers make informed decisions with confidence. Our system detects subclinical conditions like mastitis and inflammation, tracks key nutrient levels, and delivers lab-level accuracy directly during the milking process. With instant alerts and actionable insights, Linok empowers you to optimize operations, reduce costs, and ensure the highest standards of milk quality—every time.',
  features: [
    {
      id: 1,
      icon: expIcon1,
      title: 'Professional and Innovative Team',
      description:
        'Driven by passion and expertise, our team combines innovation, industry knowledge, and commitment to transform the dairy sector. Together, we work tirelessly to deliver cutting-edge solutions that empower farmers and elevate industry standards.',
    },
    {
      id: 2,
      icon: expIcon2,
      title: 'Affordable, Real-Time Detection of Mastitis and Milk Quality Monitoring',
      description:
        'Linok delivers affordable, real-time mastitis detection and milk quality monitoring, empowering healthier herds, reduced costs, optimized operations, and improved dairy productivity',
    }
  ],
  clients: [
    {
      id: 1,
      logo: geekwire,
      name: 'geekwire',
      link: '#1',
    },
    {
      id: 2,
      logo: slack,
      name: 'slack',
      link: '#2',
    },
    {
      id: 3,
      logo: envato,
      name: 'envato',
      link: '#3',
    },
    {
      id: 4,
      logo: usaToday,
      name: 'usa today',
      link: '#4',
    },
    {
      id: 5,
      logo: forbes,
      name: 'forbes',
      link: '#5',
    },
    {
      id: 6,
      logo: evernote,
      name: 'evernote',
      link: '#6',
    },
  ],
};

/* ------------------------------------ */
// Features data section
/* ------------------------------------ */
import Image1 from '../../assets/image/appCreative/feature/slide1.png';
import Image2 from '../../assets/image/appCreative/feature/slide2.png';
import Image3 from '../../assets/image/appCreative/feature/slide3.png';
import Image4 from '../../assets/image/appCreative/feature/slide4.png';
import Image5 from '../../assets/image/appCreative/feature/slide5.png';
import Image6 from '../../assets/image/appCreative/feature/slide6.png';

export const features = {
  title: 'Unique Capabilities and Benefits',
  // subtext_a:
  //   'We aspire to spearhead the Dairy Industry revolution by ensuring exceptional milk monitoring and optimizing industry-wide revenues across the entire value chain.',
  // subtext_b: 'Through these efforts, we aim to reduce antibiotic usage, enhance animal welfare, and leverage our advanced proprietary AI capabilities for real-time and big-data analysis',
  items: [
    {
      id: 1,
      thumbnail: Image1,
      title: 'Affordable Solution',
      description:
        'Cost-effective innovation empowering farmers with advanced tools to optimize dairy operations effortlessly.',
    },
    {
      id: 2,
      thumbnail: Image2,
      title: 'Inflammation detection accuracy',
      description:
        'Reliable detection of subclinical conditions, ensuring healthier herds and improved productivity',
    },
    {
      id: 3,
      thumbnail: Image3,
      title: 'Macronutrients Analysis Accuracy',
      description:
        'Lab-grade precision in monitoring key milk nutrients directly during the milking process.',
    },
    {
      id: 4,
      thumbnail: Image4,
      title: 'Real time Data for Farmer & Dairy site',
      description:
        'Instant, actionable insights enabling smarter decisions for farmers and dairy operators.',
    },
    {
      id: 5,
      thumbnail: Image5,
      title: 'AI & ML Technology',
      description:
        'Revolutionizing dairy management with cutting-edge AI and machine learning analytics',
    },
    {
      id: 6,
      thumbnail: Image6,
      title: 'In-hand Management Application',
      description:
        'Seamless, user-friendly app for real-time monitoring and control at your fingertips.',
    },
  ],
};

/* ------------------------------------ */
// Pricing data section
/* ------------------------------------ */
export const pricing = {
  title: 'Meet our exciting Pricing Plan',
  slogan: 'We designed our pricing plan with affordable price for users',
  pricingFeature: [
    {
      id: 1,
      name: 'Full Access Library',
    },
    {
      id: 2,
      name: 'Multiple user',
    },
    {
      id: 3,
      name: 'Refund Policy',
    },
    {
      id: 4,
      name: 'Google Analytics',
    },
    {
      id: 5,
      name: '24/7 support',
    },
  ],
  pricingItems: [
    {
      id: 1,
      package_name: 'Starter Pack',
      price: '18',
      trial_day: 15,
      isRecommended: false,
      features: [
        {
          id: 1,
          name: 'Full Access Library',
          isAvailable: true,
        },
        {
          id: 2,
          name: 'Multiple user',
          isAvailable: true,
        },
        {
          id: 3,
          name: 'Refund Policy',
          isAvailable: false,
        },
        {
          id: 4,
          name: 'Google Analytics',
          isAvailable: false,
        },
        {
          id: 5,
          name: '24/7 support',
          isAvailable: false,
        },
      ],
    },
    {
      id: 2,
      package_name: 'Premium Pack',
      price: '29',
      trial_day: 30,
      isRecommended: true,
      features: [
        {
          id: 1,
          name: 'Full Access Library',
          isAvailable: true,
        },
        {
          id: 2,
          name: 'Multiple user',
          isAvailable: true,
        },
        {
          id: 3,
          name: 'Refund Policy',
          isAvailable: true,
        },
        {
          id: 4,
          name: 'Google Analytics',
          isAvailable: false,
        },
        {
          id: 5,
          name: '24/7 support',
          isAvailable: false,
        },
      ],
    },
    {
      id: 3,
      package_name: 'Ultimate Pack',
      price: '35',
      trial_day: 45,
      isRecommended: false,
      features: [
        {
          id: 1,
          name: 'Full Access Library',
          isAvailable: true,
        },
        {
          id: 2,
          name: 'Multiple user',
          isAvailable: true,
        },
        {
          id: 3,
          name: 'Refund Policy',
          isAvailable: true,
        },
        {
          id: 4,
          name: 'Google Analytics',
          isAvailable: true,
        },
        {
          id: 5,
          name: '24/7 support',
          isAvailable: false,
        },
      ],
    },
  ],
};

/* ------------------------------------ */
// Testimonial data section
/* ------------------------------------ */
import reviewer1 from '../../assets/image/appCreative/client/client-avatar-1.jpg';
import reviewer2 from '../../assets/image/appCreative/client/client-avatar-2.jpg';
import reviewer3 from '../../assets/image/appCreative/client/client-avatar-3.jpg';

export const testimonial = {
  title: 'What our clients say about us',
  slogan: 'Some inspirational feedback from our customers on twitter',
  reviews: [
    {
      id: 1,
      description:
        'OMG! I cannot believe that I have got a brand new landing page after getting this template we are able to use our most used e-commerce for your branding site to make a profitable and make it cool with fast loading experience.',
      avatar: reviewer1,
      name: 'Jonathan Taylor',
      designation: 'CEO at Creativex',
      twitterProfile: 'https://twitter.com/redqinc',
    },
    {
      id: 2,
      description:
        '@redqteam is great for creating with landing pages within minutes! It then actually takes less time…',
      avatar: reviewer2,
      name: 'Gavin Park',
      designation: 'CEO at Orbital',
      twitterProfile: 'https://twitter.com/redqinc',
    },
    {
      id: 3,
      description:
        'Whenever I need to create a new cool ecommerce site for clients @redqteam is my solution is the best agency. We are super excited about it.',
      avatar: reviewer3,
      name: 'Betty Norton',
      designation: 'Freelance Designer',
      twitterProfile: 'https://twitter.com/redqinc',
    },

    {
      id: 4,
      description:
        'Whenever I need to create a new cool ecommerce site for clients @redqteam is my solution is the best agency. We are super excited about it. profitable and make it cool with fast loading experience & it make the site more customizable & fluent.',
      avatar: reviewer3,
      name: 'Betty Norton',
      designation: 'Freelance Designer',
      twitterProfile: 'https://twitter.com/redqinc',
    },
    {
      id: 5,
      description:
        'We are really excited that we have got a brand new landing page after getting this template we are able to use our most used e-commerce for your branding site to make a profitable and make it cool with fast loading experience.',
      avatar: reviewer1,
      name: 'Jonathan Taylor',
      designation: 'CEO at Creativex',
      twitterProfile: 'https://twitter.com/redqinc',
    },
    {
      id: 6,
      description:
        'Whenever I need to create a new cool ecommerce site for clients, @redqteam is my solution is the best agency. ',
      avatar: reviewer3,
      name: 'Betty Norton',
      designation: 'Freelance Designer',
      twitterProfile: 'https://twitter.com/redqinc',
    },
  ],
};

/* ------------------------------------ */
// Available Store data section
/* ------------------------------------ */
import availableThumb from '../../assets/image/appCreative/availableThumb.png';

export const availableStore = {
  title: 'We are available in both play store & app store ✌️',
  description:
    'There will be a day–in our lifetime–when we get to celebrate every person on the planet having access.',
  thumb: availableThumb,
  numberPrefix: [
    {
      label: '+13',
      value: '13',
    },
    {
      label: '+14',
      value: '14',
    },
    {
      label: '+15',
      value: '15',
    },
    {
      label: '+16',
      value: '16',
    },
    {
      label: '+17',
      value: '17',
    },
    {
      label: '+18',
      value: '18',
    },
  ],
};

/* ------------------------------------ */
// Faq data section
/* ------------------------------------ */
export const faq = {
  title: 'Frequently Ask Question',
  slogan: 'What are you looking for and find the solution on our FAQ page',
  faqs: [
    {
      id: 1,
      question: 'Which domain should I purchase?',
      answer:
        "We make it easy to move to CometNine. Simply contact us and we'll move your hosting account from any other provider, regardless of the control panel. If at anytime your website is down for more than 0.1% result",
    },
    {
      id: 2,
      question: 'Can I upgrade or downgrade my web hosting plan',
      answer:
        'The pricing made me a little hesitant at first but I have been pleasantly surprised by the level of care given by CometNine.',
    },
    {
      id: 3,
      question: 'How do I upgrade the storage capacity of my hosting plan?',
      answer:
        'Stop your viewers from getting distracted. Publish videos to your own Channel and rest easy knowing viewers won’t be annoyed by ads or pulled down a rabbit hole of unrelated videos.',
    },
    {
      id: 4,
      question: 'What are some tips when choosing a name?',
      answer:
        'Get your website tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home collect a sample from management news.',
    },
    {
      id: 5,
      question: 'What is in Motion Hosting’s uptime rate?',
      answer:
        'Designed with beginners in mind and packed with advanced features developers will love. Start with a quick and simple install',
    },
    {
      id: 6,
      question: 'What if I need help choosing the right domain?',
      answer:
        'Create a hub for cross-functional work that also works with all your other tools. Centralize and standardize communication with Miro. All premium functional are included here with updates.',
    },
    {
      id: 7,
      question: 'Learn from community on Brandwagon',
      answer:
        'Brian Halligan knows that you need more than a great product to have a great brand. Hear his thoughts & score a peek at our wagon.',
    },
  ],
};

/* ------------------------------------ */
// Footer data section
/* ------------------------------------ */
import { IconBrandFacebook, IconBrandLinkedin, IconBrandTwitter } from '@tabler/icons-react';
import footerLogo from '../../assets/image/appCreative/logo.png';

export const footerWidget = {
  logo: footerLogo,
  siteName: 'RedQ, Inc',
  siteUrl: '#',
  socialLinks: [
    {
      id: 1,
      icon: <IconBrandFacebook />,
      name: 'facebook',
      link: '#',
    },
    {
      id: 2,
      icon: <IconBrandTwitter />,
      name: 'twitter',
      link: '#',
    },
    {
      id: 3,
      icon: <IconBrandLinkedin />,
      name: 'linkedin',
      link: '#',
    },
  ],
  navigation: {
    title: 'Quick Navigation',
    menuItems: [
      {
        id: 1,
        url: '/calculator',
        text: 'ROI Calculator',
      },
      {
        id: 2,
        url: '/why-linok',
        text: 'Why Linok?',
      },
      {
        id: 3,
        url: '/about-us',
        text: 'About Us',
      },
      // {
      //   id: 3,
      //   url: '/posts',
      //   text: 'Linok Blog',
      // },
      {
        id: 4,
        url: '/contact-us',
        text: 'Contact Us',
      },
    ],
  },
  ourInformation: {
    title: 'Linok For You',
    menuItems: [
      {
        id: 1,
        url: '/contact-us',
        text: 'Request a demo',
      },
      {
        id: 2,
        url: '/become-partner',
        text: 'Become a Partner',
      },
      {
        id: 3,
        url: '/calculator',
        text: 'ROI Calculator',
      }
    ],
  },
  ourContacts: {
    title: 'Contact Us',
    menuItems: [
      {
        id: 1,
        text: 'Email: info@linoktech.com',
        link: 'mailto:info@linoktech.com'
      },
      // {
      //   id: 2,
      //   text: 'HQ @ Tel-Aviv, Israel',
      // },
      // {
      //   id: 3,
      //   text: 'Direct: +972(52)834-5944',
      // }
    ],
  },
};

/* ------------------------------------ */
// Testimonial data section
/* ------------------------------------ */

import Member1Image from '../../assets/image/appCreative/team/member-1.jpg';
import Member2Image from '../../assets/image/appCreative/team/member-2.jpg';
import Member3Image from '../../assets/image/appCreative/team/member-3.jpg';
import Member4Image from '../../assets/image/appCreative/team/member-4.jpg';
import Member5Image from '../../assets/image/appCreative/team/member-5.jpg';
import Member6Image from '../../assets/image/appCreative/team/member-6.jpg';
import Member7Image from '../../assets/image/appCreative/team/omer-arad.jpg';
import Member8Image from '../../assets/image/appCreative/team/dor-sofer.jpg';

export const Team = [
  {
    id: 1,
    name: 'Boaz Grof',
    designation: 'Founder & CEO',
    infos: [
      'Dairy farming expert and manager with over 10 years of hands-on experience',
      'Artificial insemination and genetics expert with deep industry knowledge',
      'Holds a practical dairy farming engineer degree'
    ],
    avatar_url: Member1Image,
    social_icon: 'flaticon-linkedin',
  },
  {
    id: 2,
    name: 'Omer Arad',
    designation: 'CTO',
    infos: [
      '15+ years leading AI, IoT & robotics, working with global Fortune 500 companies',
      'Former VP R&D at Verobotics, led development of autonomous facade maintenance robots',
      'Forbes 30Under30 honoree with B.Sc. in Computer Science from Technion']
    ,
    avatar_url: Member7Image,
    social_icon: 'flaticon-twitter-logo-silhouette',
  },
  {
    id: 3,
    name: 'Dor Sofer',
    designation: 'Data Scientist – ML Specialist',
    infos: [
      'Experienced data scientist specializing in machine learning, deep learning, and computer vision',
      'Led development of data-driven solutions across complex imaging and analytical domains',
      'Holds a B.Sc. in Structural Engineering']
    ,
    avatar_url: Member8Image,
    social_icon: 'flaticon-twitter-logo-silhouette',
  },
  {
    id: 4,
    name: 'Dr. Yaniv Okinine',
    designation: 'Chief Scientific Officer',
    infos: [
      'Holds a Ph.D. from Ben-Gurion University with 13+ years as multidisciplinary technology manager',
      'Extensive expertise in computational optical sensing, imaging systems, and analysis algorithms',
      'Former CTO of medical startup, led development of spectral device for urine analysis'
    ],
    avatar_url: Member3Image,
    social_icon: 'flaticon-linkedin',
  }

];

export const Advisory = [
  {
    id: 1,
    name: 'Reuven Harrison',
    designation: 'Founding Chairman',
    infos: [
      'Serial tech entrepreneur with a track record of building high-growth startups',
      'Co-founder and former CTO of Tufin, a leader in network security',
      'Advisor to select startups on product, business strategy, and deep-tech innovation'
    ],
    avatar_url: Member2Image,
    social_icon: 'flaticon-twitter-logo-silhouette',
  },
  {
    id: 3,
    name: 'Sergio Renato Fischlim',
    designation: 'Advisor',
    infos: [
      '38 years of experience managing dairy farms with BA in Economics',
      'Chairman of the Israeli Milk Producers Association (ICBA)',
      'Chairman of the Jordan Valley and Golan Dairy Milk Producers Association',
    ], avatar_url: Member5Image,
    social_icon: 'flaticon-twitter-logo-silhouette',
  }
  // {
  //   id: 4,
  //   name: 'P. Embry Canterbury',
  //   designation: 'Advisor',
  //   infos: [
  //     'CEO of Hibernia Resources IV, LLC and Canterbury Family Office',
  //     'Co-founded Hibernia Resources in 2007, leading multiple successful exits',
  //     'Oversees diverse portfolio including 1,700-acre working cattle ranch in South Texas'
  //   ], avatar_url: Member4Image,
  //   social_icon: 'flaticon-twitter-logo-silhouette',
  // },
];


/* ------------------------------------ */
// Blog data section
/* ------------------------------------ */

import Blog1Image from '../../assets/image/blog/1/cow-grazing-green-meadow.jpg';
import Blog2Image from '../../assets/image/blog/2/blog2.jpg';

export const blogPosts = [
  {
    id: "1",
    title: "Exciting Times at Linok: U.S. Trip, Funding Round, and New Website Launch",
    image: Blog1Image,
    date: "March 5, 2025",
    content: [
      { subtitle: "", content: "At Linok, we’re thrilled to share some incredible milestones as our journey gains momentum. Next week, I’ll be traveling to the U.S. to meet with dairy industry professionals, including dairy managers, and introduce them to Linok’s cutting-edge real-time milk monitoring solution. This trip marks a significant step in building connections and showcasing how our technology is transforming dairy operations." },
      { subtitle: "", content: "Meanwhile, we’re actively raising a funding round to fuel our growth and innovation. This exciting phase is a testament to the growing belief in Linok’s potential to revolutionize the dairy industry." },
      { subtitle: "", content: "Finally, we’re proud to announce the launch of our brand-new website, www.linoktech.com, designed by Amir Foghel, to provide a deeper look into what we do, how our solutions work, and the value we bring to dairy farmers worldwide." },
      { subtitle: "", content: "Stay tuned for more updates as we continue to build partnerships and drive change in the dairy industry!" }
    ],
    quotes: [] as { quote: string; name: string }[],
  },
  {
    id: "2",
    title: "Momentum at Linok: Closing Our Seed Round and Welcoming Two Key Team Members",
    image: Blog2Image,
    date: "July 22, 2025",
    content: [
      { subtitle: "", content: "We’re excited to share two major milestones that signal strong momentum as we continue building the future of real-time milk quality monitoring." },
      { subtitle: "Seed Round Closed – Led by Watchfire Ventures", content: "We’ve officially closed our seed funding round, led by <a href='https://watchfireventures.com//' target='_blank'>Watchfire Ventures</a>, with participation from <a href='https://www.barrelvc.com/' target='_blank'>Barrel Ventures</a>, two exceptional firms that back visionary teams tackling real-world, high-impact problems. Their support validates our approach to bringing lab-grade, reagent-free milk analysis directly into the milking process, and it gives us the resources to accelerate development, scale deployments, and grow our commercial footprint." },
      { subtitle: "Two Key Hires: Omer Arad and Dor Sofer", content: "We’re also proud to welcome two exceptional talents to the Linok team:\n• <a href='https://www.linkedin.com/in/omerarad/' target='_blank'>Omer Arad</a>, who brings deep expertise in AI, IoT, and data-driven systems, designing scalable technologies that power real-world products and drive business innovation.\n• <a href='https://www.linkedin.com/in/dor-sofer-67a94a16a/' target='_blank'>Dor Sofer</a>, a data scientist with a strong background in signal processing, machine learning, and turning raw data into actionable insights.\nTheir experience and energy strengthen our ability to deliver precision, reliability, and value at scale." },
      { subtitle: "", content: "With the right partners and the right people, we’re charging ahead, and this is just the beginning.\n\n<b>Stay tuned.\nTeam Linok</b>" }
    ],
    quotes: [] as { quote: string; name: string }[],
  },
  // {
  //   id: "2",
  //   title: "LinokTech: Transforming the Dairy Industry with AI and Data-Driven Insights",
  //   image: "https://cdn.britannica.com/55/174255-050-526314B6/brown-Guernsey-cow.jpg",
  //   date: "March 6, 2025",
  //   content: [
  //     { subtitle: "", content: "The global dairy industry is at a turning point. With rising concerns over sustainability, animal welfare, and food security, the demand for innovative solutions has never been greater. LinokTech is stepping up to the challenge—leveraging cutting-edge AI and real-time data analytics to empower dairy farmers with actionable insights that drive efficiency, profitability, and ethical farming practices." },
  //     { subtitle: "About LinokTech: A Vision for a Smarter Dairy Industry", content: "At LinokTech, we believe that data-driven decision-making is the key to revolutionizing dairy farming. Our mission is simple yet ambitious:\nOptimize dairy operations through real-time monitoring and AI-driven insights.\nEnhance animal welfare by reducing unnecessary antibiotic use and improving herd health.\nBoost sustainability by minimizing waste and maximizing resource efficiency.\nWith a strong focus on real-time big data analytics, LinokTech provides dairy farmers with a comprehensive, AI-powered monitoring platform that delivers instant insights into herd health, milk quality, and operational performance. This approach not only improves efficiency and profitability but also aligns with global efforts to create a more sustainable and responsible dairy sector." },
  //     { subtitle: "The Team: Passionate Innovators Driving Change", content: "LinokTech is built by a team of technology experts, data scientists, and dairy industry professionals who share a common goal—to bridge the gap between traditional dairy farming and advanced technological solutions.\nOur team members bring deep expertise in:\n🔹 AI and machine learning, ensuring our analytics platform continuously improves and adapts.\n🔹 Big data processing, allowing for instant, reliable insights that drive smarter decision-making.\nAgritech and animal health, ensuring that our solutions are not just technologically advanced but also practical and effective for farmers.\nTogether, we are committed to pioneering the future of dairy farming—one that is more efficient, sustainable, and profitable." },
  //     { subtitle: "Market Opportunity: The Growing Need for AI in Dairy Farming", content: "The dairy industry is undergoing a major digital transformation, and LinokTech is at the forefront of this evolution. With increasing pressures from regulations, sustainability goals, and consumer demands for transparency, farmers are looking for technology-driven solutions to stay competitive" },
  //   ],
  //   quotes: [
  //     { quote: "The only limit to our realization of tomorrow is our doubts of today.", name: "Franklin D. Roosevelt" }
  //   ]
  // }
];
